<div class="container table-container">
    <mat-toolbar>
        <span>Plantillas</span>
        <span class="sgd-spacer"></span>
        <button mat-flat-button (click)="onAddPlantillaMemo()">Nuevo</button>
    </mat-toolbar>

    <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="codigoPtlMemo">
            <th mat-header-cell *matHeaderCellDef> ID </th>
            <td mat-cell *matCellDef="let element"> {{element.codigoPtlMemo}} </td>
        </ng-container>

        <ng-container matColumnDef="nomPlantilla">
            <th mat-header-cell *matHeaderCellDef> Nombre </th>
            <td mat-cell *matCellDef="let element"> {{element.nomPlantilla}} </td>
        </ng-container>

        <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef> Descripción </th>
            <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
        </ng-container>

        <ng-container matColumnDef="definicCampo">
            <th mat-header-cell *matHeaderCellDef> Plantilla </th>
            <td mat-cell *matCellDef="let element"> {{element.definicCampo}} </td>
        </ng-container>


        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button (click)="onUpdatePlantillaMemo(element)" matTooltip="Editar" type="button">
                    <mat-icon>edit</mat-icon>
                </button>
                <!-- <button mat-icon-button matTooltip="Eliminar" type="button">
                    <mat-icon>cancel</mat-icon>
                </button> -->
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>